// material-ui
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import AuthCardWrapper from '../AuthCardWrapper';
import AuthWrapper1 from '../AuthWrapper';
import AuthLogin from '../auth-forms/AuthLogin';

import { ReactComponent as PersonIcon } from 'assets/icons/auth/person.svg';
import AuthLeftWrapper from '../AuthLeftWrapper';
import CreatePassword from './createPassword';

// ================================|| AUTH1 - LOGIN ||================================ //

const CreateSecondaryUserPass = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AuthWrapper1>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ minHeight: '100vh' }}
      >
        {/* Left */}
        <AuthLeftWrapper />

        {/* Right  */}
        <Grid
          item
          container
          justifyContent="center"
          md={6}
          lg={6}
          sx={{ my: 3 }}
        >
          <AuthCardWrapper>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                <PersonIcon />
              </Grid>
              <Grid item xs={12} mb={4}>
                <Typography gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
                  Hi, Create Password
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <CreatePassword loginProp={1} />
              </Grid>
            </Grid>
          </AuthCardWrapper>
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default CreateSecondaryUserPass;
